"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.possibleFiletypes = exports.isSkipped = exports.initialValues = exports.icon = exports.getMetricsPrefix = exports.getMetrics = exports.getDataDefinitions = exports.getDataConnectorsValues = exports.getDataConnectors = exports.fields = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var possibleFiletypes = exports.possibleFiletypes = [{
  value: 'pdf',
  label: 'PDF',
  list: ['pdf']
},
// { value: 'word', label: 'Word', list: ['doc', 'docx'] },
// { value: 'excel', label: 'Excel', list: ['xls', 'xlsx', 'csv'] },
// { value: 'powerpoint', label: 'Power Point', list: ['ppt', 'pptx'] },
{
  value: 'rtf',
  label: 'Rich Text Format',
  list: ['rtf']
}, {
  value: 'txt',
  label: 'Text File',
  list: ['txt']
}, {
  value: 'image',
  label: 'Image',
  list: ['png', 'jpg', 'jpeg', 'gif', 'svg']
}, {
  value: 'audio',
  label: 'Audio',
  list: ['mp3']
}, {
  value: 'video',
  label: 'Video',
  list: ['mp4']
}];
var fields = exports.fields = ['question', 'description', 'filename', 'filetypes', 'maxFileSize', 'isRequired', 'requiredErrorMessage', 'isRequiredExpanded', 'isFiletypesExpanded'];
var initialValues = exports.initialValues = {
  question: '<p><strong>Upload file</strong></p>',
  filename: 'document',
  filetypes: ['pdf'],
  maxFileSize: 50,
  isRequired: false,
  requiredErrorMessage: 'A file is required.',
  isRequiredExpanded: false,
  isFiletypesExpanded: false
};
var icon = exports.icon = /*#__PURE__*/_react["default"].createElement("i", {
  className: "glyphicon glyphicon-upload"
});
var validate = exports.validate = function validate(values) {
  var errors = {};
  if (typeof values.maxFileSize !== 'number' || values.maxFileSize < 1 || values.maxFileSize > 1000) {
    errors.maxFileSize = 'The value should be between 1 and 1000';
  }
  return errors;
};
var getMetricsPrefix = exports.getMetricsPrefix = function getMetricsPrefix() {
  return 'fi';
};
var getDataDefinitions = exports.getDataDefinitions = function getDataDefinitions(id, settings) {
  var prefix = getMetricsPrefix();
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, id + '_answer', {
    title: (0, _cccisdSurveyCommon.stripTags)(settings.question),
    titleHtml: settings.question,
    type: 'text',
    questionType: 'fileUpload',
    variableType: 'qualitative',
    tags: {
      system: ['answer', 'fileUpload']
    },
    reportHeader: "".concat(prefix, "_").concat(id)
  }), id + '_filename', {
    title: (0, _cccisdSurveyCommon.stripTags)(settings.question),
    titleHtml: settings.question,
    type: 'text',
    questionType: 'fileUpload',
    variableType: 'qualitative',
    tags: {
      system: ['answer']
    },
    reportHeader: "".concat(prefix, "_").concat(id, "_filename")
  }), id + '_filesize', {
    title: (0, _cccisdSurveyCommon.stripTags)(settings.question),
    titleHtml: settings.question,
    type: 'number',
    questionType: 'fileUpload',
    variableType: 'qualitative',
    tags: {
      system: ['answer']
    },
    reportHeader: "".concat(prefix, "_").concat(id, "_filesize")
  }), id + '_filedate', {
    title: (0, _cccisdSurveyCommon.stripTags)(settings.question),
    titleHtml: settings.question,
    type: 'text',
    questionType: 'fileUpload',
    variableType: 'qualitative',
    tags: {
      system: ['answer', 'isoDate']
    },
    reportHeader: "".concat(prefix, "_").concat(id, "_filedate")
  });
};
var getMetrics = exports.getMetrics = function getMetrics(id, settings, answer) {
  if (!answer) {
    return _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, id + '_answer', null), id + '_filename', null), id + '_filesize', null), id + '_filedate', null);
  }
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, id + '_answer', answer.token), id + '_filename', answer.name), id + '_filesize', answer.size), id + '_filedate', answer.lastModified);
};
var getDataConnectors = exports.getDataConnectors = function getDataConnectors(settings) {
  var connectors = {};
  connectors.filename = {
    type: 'string',
    title: 'Filename'
  };
  return connectors;
};
var getDataConnectorsValues = exports.getDataConnectorsValues = function getDataConnectorsValues(settings, answer) {
  return {
    filename: function filename() {
      return (answer === null || answer === void 0 ? void 0 : answer.name) || '';
    }
  };
};
var isSkipped = exports.isSkipped = function isSkipped(_ref4) {
  var settings = _ref4.settings,
    answer = _ref4.answer;
  return !answer;
};